import { login_member } from '@/api';
export default {
  name: "login-phone-no",

  data() {
    return {
      form: {
        user: "",
        password: ""
      },
      rules: {
        user: [{
          required: true,
          message: this.$t("Please enter your member no."),
          trigger: "blur"
        }]
      }
    };
  },

  methods: {
    submitForm(form) {
      this.$refs[form].validate(async valid => {
        if (valid) {
          this.$emit('showErr', false);
          let {
            data
          } = await login_member(this.form.user, this.form.password);

          if (data.message == "OK") {
            if (process.env.NODE_ENV !== "development") {
              window.self.location.href = "https://overlander.com.hk/";
            }
          } else {
            this.$emit('showErr', data.message);
          }
        }
      });
    }

  }
};